import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Markdown from './Markdown';
import { Button, Popup, VerticalSpacing, Spinner } from './Boneyard';
import {
  useTranslations,
  withTranslations,
} from '../graphql/components/TranslationsProvider';
import ERROR_BOUNDARY_TRANSLATIONS_QUERY from './errorBoundary/errorBoundaryTranslations.query.graphql';
import { peacockBlue, waterBlue } from '@g4/boneyard/lib/theme/colors';
import { RECOVERABLE_ERROR_BOUNDARY } from '../../automationHooks.json';
import { Box } from './Boneyard';

const propTypes = {
  error: PropTypes.string.isRequired,
  isPopupOpen: PropTypes.bool.isRequired,
  redirectTo: PropTypes.string.isRequired,
  hideCloseButton: PropTypes.bool,
  setIsPopupOpen: PropTypes.func,
  clearPageError: PropTypes.func,
};

const Title = styled.h1`
  font-size: 26px;
  text-align: center;
  color: ${waterBlue};
  margin-bottom: 14px;
  font-weight: 600;
  ${props => props.theme.query.md} {
    padding: 0 35px;
  }
`;

const Content = styled.div`
  text-align: center;
  color: ${peacockBlue};
  line-height: 1.6;
  font-size: 14px;

  p:not(:last-child) {
    margin-bottom: 7px;
  }

  ${props => props.theme.query.md} {
    padding: 0 45px;
  }
`;
const StyledButton = styled(Button)`
  width: 100%;
  ${props => props.theme.query.md} {
    max-width: 200px;
  }
`;

const ErrorPopup = ({
  error,
  redirectTo,
  isPopupOpen,
  setIsPopupOpen,
  clearPageError,
  hideCloseButton,
}) => {
  const translations = useTranslations()?.errors;

  const [isRedirecting, toggleRedirecting] = useState(false);

  const closePopup = () => {
    clearPageError && clearPageError();
    setIsPopupOpen && setIsPopupOpen(false);
  };

  const onRedirect = () => {
    if (!isRedirecting) {
      window.location.href = redirectTo;
    }
    toggleRedirecting(true);
  };

  return (
    <Popup
      open={isPopupOpen}
      automationHook={RECOVERABLE_ERROR_BOUNDARY.hook}
      onRequestClose={closePopup}
      displayCloseIcon={!hideCloseButton}
    >
      <Box maxWidth="500px" d="flex" direction="column" alignItems="center">
        <Title>
          <Markdown
            source={translations[`${error}_title`]}
            data={{
              ellipsis: '...',
            }}
          />
        </Title>
        <Content>
          <Markdown source={translations[`${error}_message`]} />
        </Content>
        <VerticalSpacing size={4} />
        <StyledButton onClick={onRedirect} fullWidth disabled={isRedirecting}>
          {isRedirecting ? (
            <Spinner size="xsmall" appearance="light" />
          ) : (
            translations[`${error}_backButtonLabel`]
          )}
        </StyledButton>
      </Box>
    </Popup>
  );
};

ErrorPopup.propTypes = propTypes;

export default withTranslations(ERROR_BOUNDARY_TRANSLATIONS_QUERY, ErrorPopup);
